export const TooltipStyle = {
  color: 'black',
  background: 'white',
  border: '1px solid black',
  borderRadius: 0,
  '& .MuiTooltip-popper[data-popper-placement*="top"] .MuiTooltip-tooltip': {
    m: 0
  }
}

export const HelpIconStyle = {
  position: 'absolute',
  right: '10px',
  top: '10px'
}